<template>
    <b-container id="Steps" class="Steps wrapper">
      <b-row>
        <b-col cols="12">
          <h2 class="tac">{{$t('stepsDiv.title')}}</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div id="triggerStep1"></div>
          <p class="stepsMsg">{{$t('stepsDiv.msg')}}</p>
          <div id="triggerStep2"></div>
        </b-col>
      </b-row>

      <b-row class="center flexSteps">
        <b-col v-for="(step, i) in myJson.steps" :key="i" md="4" sm="4" cols="12">
          <step 
            :trigger="'triggerStep'+i"
            :anim="'animStep'+i"
            :alt="$t('stepsDiv.steps['+i+'].title')"
            :img="$t('stepsDiv.steps['+i+'].img')"
            :title="$t('stepsDiv.steps['+i+'].title')" 
            :msg="$t('stepsDiv.steps['+i+'].msg')"/>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import step from "./Step.vue"
import json from '@/locales/en.json'

export default {
    name: 'Steps',
    data: function() {
        return {
            myJson: json.stepsDiv
        }
    },
    components: {
        step
    }
} 
</script>

<style scoped lang="scss">
@import '@/assets/style/steps.scss';
</style>